"use client"

import * as React from "react";
import {useEffect} from "react";
import ProductsSortSelect from "./products-sort-select";
import ProductsFiltersDialog from "./products-filters-dialog";
import {useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";
import {useCookies} from "react-cookie";
import {setCardView} from "@/redux/product.params.slice";
import Stack from "@mui/material/Stack";
import {Box, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {IProductNew} from "@/types/product";


export default function ProductsHeader({productsData, isLoading}: {
    isLoading: boolean, productsData: IProductNew | null;
}) {
    const theme = useTheme()
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'))
    const searchText = useAppSelector((state: RootState) => state.products.SearchText)
    const [cookie, setCookie] = useCookies(["CardViewCookie"]);

    useEffect(() => {
        if (cookie.CardViewCookie) {
            setCardView(cookie.CardViewCookie === "true");
        } else {
            setCookie("CardViewCookie", "true");
        }
    }, []);

    const [searchDialogOpen, setSearchDialogOpen] = React.useState(false);
    const handleSearchDialogOpen = () => {
        setSearchDialogOpen(true);
    };

    const handleSearchDialogClose = () => {
        setSearchDialogOpen(false);
    };

    return (
        <>
            <Box
                flexDirection = "row-reverse"
                alignItems = "center"
                justifyContent = "space-between"
                display = {{xs: "flex", md: "none"}}
                mt={1}
                mb={3}
            >
                <Stack
                    spacing = {1}
                    direction = "row"
                    alignItems = "center"
                >
                    <Box display = "flex" alignItems = "center" >
                        <Typography
                            noWrap
                            maxWidth = "32vw"
                            color = {theme.palette.primary.main}
                            fontSize = {13}
                        >
                            {"تعداد نتایج: "}
                            {searchText ? "برای «" + searchText + "»" : ""}
                        </Typography >

                        <Typography
                            color = "primary.light"
                            fontSize = {13}
                            fontWeight = {500}
                            ml = {1}
                        >
                            {productsData?.totalCount || 0}

                        </Typography >
                    </Box >
                    <Box flexGrow = {1} />

                    <Box display = "flex" alignItems = "center" >
                        <Typography
                            noWrap
                            fontSize = {13}
                            color = {theme.palette.primary.main}
                        >
                            صفحه:
                        </Typography >
                        <Typography fontSize = {13} fontWeight = {500} ml = {1} color = "primary.light" >
                            {!isLoading ? productsData?.pageNumber : '...'}
                        </Typography >

                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            از
                        </Typography >

                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            {isLoading ? '...' : productsData?.totalPages}
                        </Typography >
                    </Box >
                </Stack >

                <Stack
                    direction = "row"
                    display = "flex"
                    justifyContent = "space-between"
                >

                    <Box display = "flex" alignItems = "center" >
                        <ProductsFiltersDialog
                            isLoading = {isLoading}
                            handleClose = {handleSearchDialogClose}
                            open = {searchDialogOpen}
                            productsData = {productsData}
                            handleOpen = {handleSearchDialogOpen}
                        />
                    </Box >
                </Stack >
            </Box >

            <Stack
                spacing = {2}
                display = {{xs: "none", md: "flex"}}
                direction = "row"
                alignItems = "center"
                justifyContent = "space-between"
                mt={3.3}
                mb = {2}
            >
                <ProductsSortSelect />

                <Box display = "flex" gap = {2} alignItems = "center" >
                    <Box display = "flex" >
                        <Typography
                            fontSize = {14}
                            color = {theme.palette.primary.main}
                            maxWidth = "16vw"
                            noWrap

                        >
                            تعداد نتایج
                            {searchText ? " برای «" + searchText + "»" : ""}:
                        </Typography >
                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            {productsData?.totalCount || 0}

                        </Typography >

                    </Box >
                    <Box display = "flex" justifyContent = "center" >
                        <Typography color = "primary.light" fontSize = {14} >
                            صفحه:
                        </Typography >

                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            {isLoading ? '...' : productsData?.pageNumber}
                        </Typography >

                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            از
                        </Typography >

                        <Typography color = "primary.light" fontSize = {14} fontWeight = {500} ml = {1} >
                            {isLoading ? '...' : productsData?.totalPages}
                        </Typography >
                    </Box >
                    {isTablet && (
                        <ProductsFiltersDialog
                            handleClose = {handleSearchDialogClose}
                            open = {searchDialogOpen}
                            handleOpen = {handleSearchDialogOpen}
                            productsData = {productsData}
                            isLoading = {isLoading}
                        />
                    )}
                </Box >
            </Stack >
        </>
    )
}